export default __webpack_public_path__ + "images/modooda_company_logo.png";